<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditProfilePicture"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-5/12 h-full md:h-5/6 w-full overflow-y-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Change your photo</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="p-2 flex flex-col justify-between items-center gap-3">
            <div class="flex items-start justify-start mr-auto">
              <label class="cursor-pointer">
                <input v-on:change="getFile" type="file" class="hidden" />
                <span
                  class="bg-gray-200 rounded-md cursor-pointer p-2 flex items-center gap-2"
                >
                  <svg
                    class="h-6 w-6 text-primary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    ></path>
                  </svg>
                  <span class="text-sm text-textColor">Upload a photo</span>
                </span>
              </label>
            </div>

            <div class="h-64 w-64 rounded-full">
              <img
                :src="
                  preview
                    ? preview
                    : currentPicture
                    ? currentPicture
                    : 'https://placehold.co/200'
                "
                alt=""
                class="h-full w-full"
              />
            </div>

            <div class="justify-start mr-auto">
              <div class="flex gap-3 justify-start">
                <button
                  type="submit"
                  :disabled="!info.File"
                  class="bg-primary rounded px-10 w-24 text-sm text-white py-2"
                >
                  Save
                </button>
                <p
                  role="button"
                  class="bg-gray-400 rounded w-24 px-2 text-center text-sm text-white py-2"
                  @click="close()"
                >
                  Cancel
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";

export default {
  name: "EditProfilePicture",
  props: ["showEditProfilePicture", "close", "currentPicture", "placeholder"],
  components: { Loader },
  data() {
    return {
      loading: false,
      create_error: null,
      create_success: null,
      preview: null,
      info: {
        EmployeeId: "",
        File: "",
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId"]),
  },
  created() {},
  methods: {
    handleCloseEdit(e) {
      e.preventDefault();
      close();
    },

    getFile({ target }) {
      const file = target.files[0];
      this.info.File = file;
      const blob = new Blob([file], { type: "*" });

      // Create a URL for the Blob
      this.preview = URL.createObjectURL(blob);
    },

    create() {
      this.loading = true;

      this.info.EmployeeId = this.getCurrentEmployeeId;
      this.loading = true;
      const options = {
        headers: {
          accept: "*/*",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      const formData = new FormData();
      formData.append("EmployeeId", this.getCurrentEmployeeId);
      formData.append("File", this.info.File);

      axios
        .put(
          `${this.getOrganization}/employee/profile/image/${this.$ApiVersion}/edit`,
          formData,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess", response.data.StatusMessage);
              this.create_success = response.data.StatusMessage;
              setTimeout(() => {
                this.create_success = null;
                this.close(this.preview);
              }, 2000);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2000);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/* Styles for the file uploader */
label.cursor-pointer {
  cursor: pointer;
}

label.cursor-pointer input.hidden {
  display: none;
}
</style>
